import router from "@ch/router";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import type { FC } from "react";
import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import CookieConsentBanner from "@ch/components/CookieConsent/CookieConsentBanner.tsx";
import AdsBlockerDetection from "./components/AdsBlockerDetection";
import AnalyticsIdentify from "./components/Analytics/AnalyticsIdentify";
import ComponentLoader from "./components/Loaders/ComponentLoader";
import useRestoreUserSession from "./helpers/hooks/useRestoreUserSession";

ChartJS.register(
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip,
  Filler,
);

const App: FC = () => {
  const { isLoading } = useRestoreUserSession();

  return (
    <>
      {/* Necessary to avoid flashing */}
      {isLoading && <ComponentLoader className="fixed z-[99999]" />}
      <AnalyticsIdentify />
      <AdsBlockerDetection />
      <RouterProvider router={router} />
      <Toaster closeButton position="top-center" richColors />
      <CookieConsentBanner />
    </>
  );
};

export default App;
